export default class PagedFilterAndSortedRequest{
    perPage:number;
    page:number;
    sorting: Array<string>;
    where: string;
    keyword: string;
}